<script>
    import { onMount, onDestroy } from "svelte";
    import Button from "./Button.svelte";
    import PlayerConfig from "./PlayerConfig.svelte";
    import { lobbyPlayerList } from "./stores";
    import { LOAD_GAMES, MODS } from "./routes";
    export let setRoute;
    let intervalId;
    onMount(() => {
        setInterval(() => {
            // Update lobbyPlayerList
            $lobbyPlayerList = globalThis.lobbyPlayerList;
        }, 500);
    });
    onDestroy(() => {
        clearInterval(intervalId);
    });
    let forceRerender = 0;
</script>

<h1>{globalThis.i18n("Game Lobby")}</h1>
<PlayerConfig />
<div class="flex gap-15 flex-direction-column">
    {#key forceRerender}
        <Button
            on:click={() => {
                globalThis.configPlayer({ lobbyReady: true });
                forceRerender+=1;
            }}
            type="button"
            text="Ready"
            class="sm"
        />
    {/key}
    <h2>{globalThis.i18n("Difficulty")}</h2>
    <div class="flex gap-15">
        <Button
            on:click={() => {
                globalThis.setDifficulty("");
            }}
            text="Normal"
            disabled={$lobbyPlayerList[0]?.clientId != globalThis.clientId}
            style="flex:0 0 0;"
            isActive={globalThis.devUnderworld.gameMode == ""}
        />
        <Button
            on:click={() => {
                globalThis.setDifficulty("hard");
            }}
            text="Hard"
            disabled={$lobbyPlayerList[0]?.clientId != globalThis.clientId}
            style="flex:0 0 0;"
            isActive={globalThis.devUnderworld.gameMode == "hard"}
        />
        <Button
            on:click={() => {
                globalThis.setDifficulty("impossible");
            }}
            text="Impossible"
            disabled={$lobbyPlayerList[0]?.clientId != globalThis.clientId}
            style="flex:0 0 0;"
            isActive={globalThis.devUnderworld.gameMode == "impossible"}
        />
    </div>
    <h2>{globalThis.i18n("Controls")}</h2>
    <div class="flex gap-15">
        <Button
            on:click={() => setRoute(LOAD_GAMES)}
            text="Load Saved Game"
            iconPath="open.png"
            disabled={$lobbyPlayerList[0]?.clientId != globalThis.clientId}
            title="Only the host may Load a saved game for a multiplayer lobby"
            style="flex:0 0 0;"
        />
        <Button
            on:click={() => setRoute(MODS)}
            text="Mods"
            class="justify-center sm"
            disabled={$lobbyPlayerList[0]?.clientId != globalThis.clientId}
            title="Only the host may set mods"
        />
    </div>
    <h2>{globalThis.i18n("Players")}</h2>
    <table id="lobby-player-list">
        <thead>
            <tr />
        </thead>
        <tbody>
            {#each $lobbyPlayerList.sort((a, _b) => {
                // Sort self to the top
                if (a === globalThis.player) {
                    return -1;
                } else {
                    return 0;
                }
            }) as { name, status, clientId, clientConnected, color, ready }}
                <tr>
                    <td>{name}</td>
                    <td>{status}</td>
                    <td
                        class="lobby-player-color"
                        style={`background-color:${color};`}
                    />
                    <td>
                        {ready}
                    </td>
                    {#if !clientConnected}
                        <td>
                            <Button
                                on:click={() => {
                                    window.pieInhabitPlayer(clientId);
                                }}
                                type="button"
                                text="Join Game As Player"
                            />
                        </td>
                    {/if}
                </tr>
            {/each}
        </tbody>
    </table>
</div>

<style>
    #lobby-player-list {
        min-width: 500px;
    }
    .lobby-player-color {
        width: 20px;
        height: 18px;
    }
    h2 {
        margin: 0;
    }
</style>
